import TopicsPage from './TopicsPage';
import TopicsPageContainer from './TopicsPage.container';

export default TopicsPageContainer(TopicsPage);
